import { Euler as e } from "three";
import { DegToRadV3 as t } from "./index5.js";
function n(r, o = new e()) {
  return o.fromArray(t(r.rot));
}
export {
  n as getEuler
};
//# sourceMappingURL=index7.js.map
